<template>
	<el-table :data="authRangeData" stripe border style="width: 100%" :span-method="setSpan">
		<el-table-column prop="authRangeS" width="150"></el-table-column>
		<el-table-column prop="authRange" label="授权范围" width="450"></el-table-column>
		<el-table-column label="标准授权">
		<template slot-scope="scope">
			<el-image class="img" fit="contain" :src="scope.row.authStandard">
			<div slot="error" class="image-slot">
				{{scope.row.authStandard}}
			</div>
			</el-image>
		</template>
		</el-table-column>
		<el-table-column label="扩展授权">
		<template slot-scope="scope">
			<el-image class="img" fit="contain" :src="scope.row.authExtend">
			<div slot="error" class="image-slot">
				{{scope.row.authExtend}}
			</div>
			</el-image>
		</template>
		</el-table-column>
	</el-table>
</template>

<script>
export default {
  name: 'authDesc',
  props: {
	
  },
  data () {
    return {
		authRangeData:[
        {
          authRangeS:'网络用途',
          authRange:'自媒体文章配图（微博、头条号、百家号、简报、微信公众号等）',
          authStandard: require('@/assets/img/right.png'),
          authExtend:require('@/assets/img/right.png'),
        },{
          authRange:'自媒体短视频或直播配图(快手、抖音等)',
          authStandard: require('@/assets/img/right.png'),
          authExtend:require('@/assets/img/right.png'),
        },{
          authRange:'电商平台详情页配图（淘宝、京东、天猫、拼多多等）',
          authStandard: require('@/assets/img/right.png'),
          authExtend:require('@/assets/img/right.png'),
        },{
          authRange:'网站、H5、APP、小程序等广告配图',
          authStandard: require('@/assets/img/right.png'),
          authExtend:require('@/assets/img/right.png'),
        },{
          authRangeS:'商业办公',
          authRange:'企业VI、项目营销策划、宣传册、楼书、企业内刊等用图',
          authStandard: require('@/assets/img/right.png'),
          authExtend:require('@/assets/img/right.png'),
        },{
          authRange:'PPT、工作汇报、商业提案、策划案等用字',
          authStandard: require('@/assets/img/right.png'),
          authExtend:require('@/assets/img/right.png'),
        },{
          authRangeS:'线下印刷',
          authRange:'宣传页、海报、画册等小型印刷物',
          authStandard: '限50万份',
          authExtend:'不限量',
        },{
          authRange:'报纸、杂志及图书等内文配图印刷',
          authStandard: '限50万份',
          authExtend:'不限量',
        },{
          authRange:'杂志及图书等封面、封底印刷',
          authStandard: require('@/assets/img/none.png'),
          authExtend:require('@/assets/img/right.png'),
        },{
          authRangeS:'媒体应用',
          authRange:'网络电视，网络视频，电影，电视节目，公共表演等',
          authStandard: require('@/assets/img/none.png'),
          authExtend:require('@/assets/img/right.png'),
        },{
          authRangeS:'户外广告',
          authRange:'易拉宝，灯箱，橱窗，车身，围挡、楼宇等户外广告',
          authStandard: require('@/assets/img/none.png'),
          authExtend:require('@/assets/img/right.png'),
        },{
          authRangeS:'转售商品',
          authRange:'如:T恤，杯子，手机壳，鼠标垫等',
          authStandard: require('@/assets/img/none.png'),
          authExtend:require('@/assets/img/right.png'),
        },{
          authRangeS:'敏感用途',
          authRange:'肖像权敏感用途：医疗、药物、保健品、养生、美容、化妆品、整形、烟草、交友等行业',
          authStandard: require('@/assets/img/none.png'),
          authExtend:'可定制',
        },{
          authRangeS:'商品LOGO',
          authRange:'企业，品牌商标宣传',
          authStandard: require('@/assets/img/none.png'),
          authExtend:'可定制买断',
        },
      ],
    }
  },
  methods: {
	setSpan({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return [4,1];
        } else if(rowIndex === 4){
          return [2,1];
        }else if(rowIndex === 6){
          return [3,1];
        }else if([9,10,11,12,13].indexOf(rowIndex) > -1){
          return [1,1];
        }else {
          return [0,0];
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
	.el-table{
      .img{
        width:100%;
        height:22px;
      }
    }
</style>
